var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 550 30",
    style: {
      backgroundColor: "#FFFFFF00"
    },
    width: "550px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path0"
  }, /*#__PURE__*/React.createElement("animate", {
    id: "d0",
    attributeName: "d",
    begin: "0s;d0.end",
    dur: "6000ms",
    fill: "remove",
    values: "m0,25 h0 ; m0,25 h550 ; m0,25 h550 ; m0,25 h0",
    keyTimes: "0;0.53333333333333;0.86666666666667;1"
  }))), /*#__PURE__*/React.createElement("text", {
    fontFamily: "\"\", monospace",
    fill: "white",
    fontSize: 15,
    dominantBaseline: "auto",
    x: "0%",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("textPath", {
    xlinkHref: "#path0",
    style: {
      fontSize: "2rem"
    }
  }, "\r\n            I'm a Senior Frontend Developer\r\n        ")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.effeabf3bbc8cda3317c4d846d89ac0b.svg";
export { ForwardRef as ReactComponent };